// Styled Components
import styled from "styled-components";

// Material UI
// import Button from "@mui/material/Button";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import InstagramIcon from "@mui/icons-material/Instagram";
import { Button } from "@material-ui/core";
import { Twitter, Instagram } from "@material-ui/icons";

import discordIcon from '../../../static/images/discord-icon.svg';

const Nav = () => {
  return (
    <Wrapper>
      <img src="./static/images/logo.png" alt="" className="logo" />

      <div className="socials">
        <Button variant="contained" className="button">
          <a href="#generate">GENERATE COMPLETE</a>
        </Button>

        <div className="icons">
          <div className="icon-wrap">
            <a
              href="https://twitter.com/shoeuzinft"
              target="_blank"
              rel="noreferrer"
            >
              <Twitter className="icon" />
            </a>
          </div>
          <div className="icon-wrap">
            <a
              href="https://discord.gg/invite/shoeuzi"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={discordIcon}
                alt=""
                className="icon"
              />
            </a>
          </div>
          <div className="icon-wrap">
            <a
              href="https://www.instagram.com/shoeuzi/"
              target="_blank"
              rel="noreferrer"
            >
              <Instagram className="icon" />
            </a>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default Nav;

const Wrapper = styled.nav`
  width: 100%;

  //
  padding: 0 200px;
  padding-top: 50px;
  @media only screen and (max-width: 1700px) {
    padding: 0 150px;
    padding-top: 50px;
  }
  @media only screen and (max-width: 1550px) {
    padding: 0 75px;
    padding-top: 50px;
  }
  @media only screen and (max-width: 1200px) {
    padding: 0 50px;
    padding-top: 50px;
  }
  @media only screen and (max-width: 1150px) {
    padding: 0 20px;
    padding-top: 50px;
  }
  //

  //
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 485px) {
    justify-content: center;
  }
  //

  .logo {
    width: 150px;
    transform: rotate(-5deg);

    @media only screen and (max-width: 768px) {
      width: 100px;
    }
    @media only screen and (max-width: 485px) {
      display: none;
    }
  }

  .socials {
    display: flex;
    align-items: center;
    gap: 10px;

    .button {
      background-color: #000;
      border-radius: 0px;
      font-size: 1rem;

      a {
        text-decoration: none;
        color: #fff;
      }

      //
      width: 225px;
      @media only screen and (max-width: 768px) {
        width: 206px;
        height: 40px;
      }
      @media only screen and (max-width: 515px) {
        font-size: 12px;
        width: 175px;
      }
      @media only screen and (max-width: 350px) {
        width: 100%;
      }

      //

      height: 50px;

      font-family: "interstate", sans-serif;
      font-weight: 700;
      font-style: normal;
    }

    .icons {
      display: flex;
      gap: 10px;

      .icon-wrap {
        background-color: #fff;

        padding: 5px;

        display: flex;
        align-items: center;
        justify-content: center;

        //
        height: 50px;
        @media only screen and (max-width: 768px) {
          width: 40px;
          height: 40px;
        }
        //
      }

      a {
        text-decoration: none;

        display: flex;
        align-items: center;

        color: #fff;
        .icon {
          width: 40px;

          font-size: 40px;

          fill: #000;

          @media only screen and (max-width: 768px) {
            font-size: 25px;
            width: 25px;
          }
        }
      }
    }
  }
`;
